import { buildEnterpriseUrl, buildManagementUrl } from './navigation';
import { useEnterpriseIdFromRoute } from './useEnterpriseIdFromRoute';

export const useEnterpriseAwareRoute = (
  route: string,
  orgId?: string
): string => {
  const enterpriseId = useEnterpriseIdFromRoute();

  return enterpriseId
    ? buildEnterpriseUrl(enterpriseId, route, orgId)
    : buildManagementUrl(route, orgId);
};
